<div class="scroll-progress-container">
  <div class="scroll-progress-bar" id="scroll-progress-bar"></div>
</div>

@if (isCleaningCategory()) {
  <app-happy-helper-banner></app-happy-helper-banner>
}

@if (howTo) {
  <div class="container" scrollProgress>
    <div class="outer_body_container_wrapper animated fadeIn">
      <section class="hero-section hero-section-how-to" id="hero_sec">
        @if (howTo?.imgUrl) {
          <img
            [ngSrc]="howTo.imgUrl!"
            fill
            priority
            [alt]="$safeNavigationMigration(howTo?.imgAltAttribute)"
            class="hero-background-img"
          />
        }
        <app-breadcrumb-list
          [partsOfUrl]="partsOfUrl"
          [imageOverlay]="true"
        ></app-breadcrumb-list>

        <div class="hero-sub-section">
          <div class="hero-section-text">
            <h1>{{ howTo.title }}</h1>
            @if (howTo.content?.sub_header) {
              <p class="sub_header">
                {{ howTo.content?.sub_header }}
              </p>
            }
            @if (isCleaningCategory()) {
              <app-generic-button-with-arrow
                [minWidth]="'300px'"
                [label]="'GENERAL.CLEANING_FIND' | translate"
                (click)="goToUserHappyHelper()"
              >
              </app-generic-button-with-arrow>
            } @else {
              <app-generic-button-with-arrow
                [minWidth]="'300px'"
                [label]="'GENERAL.HELP_NOW' | translate"
                (click)="
                  externalService.goToCreateTask({
                    titleLabel: howTo.categoryTitle,
                  })
                "
              >
              </app-generic-button-with-arrow>
            }
          </div>
        </div>
      </section>

      <!-- Desktop -->
      <div class="outer_body_container">
        <div class="table_of_content_container">
          <nav
            class="table_of_content"
            [ngClass]="{ accordionView: innerWidth < 990 }"
          >
            @if (innerWidth < 990) {
              <div
                (click)="expandTableOfContent()"
                class="expand_table_of_content"
              >
                <h2 class="mobile_h2">{{ 'PLACEHOLDERS.I' | translate }}</h2>
                @if (tableOfContentExpanded) {
                  <mat-icon>expand_less</mat-icon>
                } @else {
                  <mat-icon>expand_more</mat-icon>
                }
              </div>
            }
            <ul
              class="content"
              [ngClass]="{ isExpanded: tableOfContentExpanded }"
            >
              @if (innerWidth > 990) {
                <h2 style="font-size: 20px; padding-top: 0 !important">
                  {{ 'PLACEHOLDERS.I' | translate }}
                </h2>
              }
              @for (h2 of h2Texts; track $index) {
                <li class="item">
                  <a
                    class="item"
                    (click)="scrollTo($event, h2.id)"
                    [attr.href]="'#' + h2.id"
                  >
                    {{ h2.text }}
                  </a>
                </li>
              }
            </ul>
          </nav>
          @if (isCleaningCategory()) {
            <div class="happy-helper-reference-container">
              <app-happy-helper-reference></app-happy-helper-reference>
            </div>
          }
        </div>

        <div class="body_container">
          @if (howTo?.question) {
            <section>
              <h2>{{ howTo.question }}</h2>
              <p>
                <strong class="strong">
                  {{ answer }} {{ howTo.shortExplanation }}
                </strong>
              </p>
              <br />
              <br />
            </section>
          }
          <div class="main_text_container">
            <section
              class="content_from_mongo"
              [innerHTML]="content | safe: 'html'"
            ></section>

            <!-- youtube video -->
            @if (videoLoaded) {
              <section class="content_from_mongo">
                <h2 class="youtube_title">{{ youtubeVidTitle }}</h2>
                <div class="videoWrapper">
                  <iframe
                    width="652"
                    height="420"
                    style="border-radius: 5px"
                    [src]="youTubeVidLink"
                    title="YouTube video player"
                    frameborder="0"
                    allow="
                      accelerometer;
                      autoplay;
                      clipboard-write;
                      encrypted-media;
                      gyroscope;
                      picture-in-picture;
                    "
                    allowfullscreen
                  >
                  </iframe>
                </div>
              </section>
            }

            @if (
              howTo?.content &&
              howTo?.content?.FAQ_area &&
              howTo?.content?.FAQ_area?.length > 1
            ) {
              <!-- FAQ accordion -->
              <section
                class="page-faqs"
                itemscope
                itemtype="https://schema.org/FAQPage"
              >
                <h2 class="title">{{ 'COMPONENTS.FAQ.FULL' | translate }}</h2>
                <ul class="faq-list">
                  @for (
                    faq of howTo?.content.FAQ_area;
                    track faq;
                    let i = $index
                  ) {
                    <li
                      class="faq-list-item"
                      itemscope
                      itemprop="mainEntity"
                      itemtype="https://schema.org/Question"
                    >
                      <input
                        class="faq-list-item__toggle"
                        type="checkbox"
                        checked=""
                        [id]="'faq' + i"
                      />
                      <label
                        [for]="'faq' + i"
                        class="faq-list-item__title"
                        itemprop="name"
                      >
                        <h3>{{ faq.TITLE }}</h3>
                      </label>
                      <div
                        class="faq-list-item__answer"
                        itemscope
                        itemprop="acceptedAnswer"
                        itemtype="https://schema.org/Answer"
                      >
                        <span itemprop="text">
                          <p [innerHTML]="faq.TEXT | safe: 'html'"></p>
                        </span>
                      </div>
                    </li>
                  }
                </ul>
              </section>
            }
            <span
              >{{ 'PAGES.WRITTEN_BY' | translate }}
              <a class="author" rel="author" routerLink="/skribent/saxo">
                {{
                  howTo?.author || ('PAGES.DEFAULT_ARTICLE_AUTHOR' | translate)
                }}</a
              >
            </span>
          </div>
        </div>
      </div>
      @if (isCleaningCategory()) {
        <app-happy-helper-usps></app-happy-helper-usps>
      }

      <app-related-guides
        [entity]="howTo"
        [title]="''"
        [onlyPriceGuides]="false"
        [onlyGuides]="true"
        [otherTitle]="'PAGES.PRICE_GUIDE.RELATED' | translate"
      ></app-related-guides>
    </div>
    <app-lp-footer></app-lp-footer>
  </div>
}

@if (youtubeSchema) {
  <div [innerHTML]="youtubeSchema | jsonLd"></div>
}

<div
  [innerHTML]="$safeNavigationMigration(howTo?.how_to_schema) | jsonLd"
></div>
